module.exports = __webpack_public_path__ + "static/el-obrero-internacional-5-8fd49894f045444a3654abfc06cb71a1.png";